import angular from 'angular';
import uirouter from 'angular-ui-router';
import routing from './routes';
import datePicker from '../../directives/datePicker'

import EditProfileController from './EditProfileController';

import panel from '../../services';

export default angular.module('app.editProfile', [uirouter, panel, datePicker])
    .config(routing)
    .controller('EditProfileController', EditProfileController)
    .name;



// WEBPACK FOOTER //
// ./src/app/features/edit-profile/index.js